import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AppState } from '@state';
import * as managerActions from './manager.actions';
import * as managerSelectors from './manager.selectors';
import { ManagerOfCompany, SearchProcessesOfManagedEmployees } from 'src/app/_interfaces/manager';
import { Actions, ofType } from '@ngrx/effects';
import { filter, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ManagerFacade {
  public managedCompanies$ = this.store.select(managerSelectors.selectManagedCompanies);
  public loadingManagedCompanies$ = this.store.select(managerSelectors.selectLoadingManagedCompanies);

  public processes$ = this.store.select(managerSelectors.selectProcesses);
  public processesPagination$ = this.store.select(managerSelectors.selectProcessesPagination);
  public loadingProcesses$ = this.store.select(managerSelectors.selectLoadingProcesses);
  public getMyManagedCompaniesSuccess$ = this.actions.pipe(ofType(managerActions.getMyManagedCompaniesSuccess));

  constructor(
    private readonly store: Store<AppState>,
    private actions: Actions
  ) {}

  public getMyManagedCompanies(): void {
    this.store.dispatch(managerActions.getMyManagedCompanies());
  }

  /**
   * Returns 'managedCompanies' from the state by doing:
   * - IF managedCompanies === null -> performs request to the backend to fetch
   * - IF managedCompanies !== null (possible empty array) -> returns mangedCompanies from the state 'as is'
   * @returns Observable<ManagerOfCompany[]> - Possible empty array!
   */
  public getMyManagedCompanies$(): Observable<ManagerOfCompany[]> {
    return this.store.select(managerSelectors.selectManagedCompanies).pipe(
      tap(companies => {
        if (!companies) {
          this.getMyManagedCompanies();
        }
      }),
      filter(companies => !!companies)
    );
  }

  public searchProcessesOfManagedEmployees(opts: SearchProcessesOfManagedEmployees): void {
    this.store.dispatch(managerActions.searchProcessesOfManagedEmployees({ opts }));
  }
}
